import { Controller } from '@hotwired/stimulus'

export interface ScrollActionEvent extends Event {
  params?: ScrollToOptions
  target: HTMLElement
}

export default class ScrollController extends Controller<HTMLElement> {
  connect() {
    this.dispatch('connect')
  }

  // Public methods

  toBottom(event: ScrollActionEvent) {
    const el = event.target as HTMLElement
    const bottom = Math.max(0, el.scrollHeight - el.clientHeight)

    el.scrollTo({ top: bottom, ...event.params })
  }
}
